(() => {
  var forms = Array.from(document.querySelectorAll('form.product-form__form'));

  function bindShortDescription(form) {
    var shortDescription = form.querySelector('[data-product-short-description]');
    if (!(shortDescription instanceof HTMLElement)) return;

    var shortDescriptionText = shortDescription.querySelector('[data-product-short-description-text]');
    if (!(shortDescriptionText instanceof HTMLElement)) return;

    var shortDescriptionToggle = shortDescription.querySelector('[data-product-short-description-toggle]');
    if (!(shortDescriptionToggle instanceof HTMLButtonElement)) return;

    var readMoreLabel = shortDescriptionToggle.dataset.readMoreLabel || 'Read more';
    var readLessLabel = shortDescriptionToggle.dataset.readLessLabel || 'Read less';

    function setExpandedState(expanded) {
      shortDescription.dataset.expanded = expanded ? 'true' : 'false';
      shortDescriptionToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      shortDescriptionToggle.textContent = expanded ? readLessLabel : readMoreLabel;

      if (expanded) {
        shortDescriptionText.classList.remove(
          '[display:-webkit-box]',
          '[-webkit-box-orient:vertical]',
          '[-webkit-line-clamp:3]',
          'overflow-hidden'
        );
        shortDescriptionText.classList.add('block', 'overflow-visible');
      } else {
        shortDescriptionText.classList.remove('block', 'overflow-visible');
        shortDescriptionText.classList.add(
          '[display:-webkit-box]',
          '[-webkit-box-orient:vertical]',
          '[-webkit-line-clamp:3]',
          'overflow-hidden'
        );
      }
    }

    function updateToggleVisibility() {
      setExpandedState(false);
      var shouldShowToggle = shortDescriptionText.scrollHeight > shortDescriptionText.clientHeight + 1;
      shortDescriptionToggle.hidden = !shouldShowToggle;
    }

    shortDescriptionToggle.addEventListener('click', function () {
      var isExpanded = shortDescription.dataset.expanded === 'true';
      setExpandedState(!isExpanded);
    });

    updateToggleVisibility();
    window.addEventListener('resize', updateToggleVisibility, { passive: true });
  }

  function getProductGalleryImages() {
    var node = document.querySelector('[data-product-gallery-images-json]');
    if (!(node instanceof HTMLScriptElement)) return [];
    try {
      var data = JSON.parse(node.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  /** Keeps `?variant=` in the address bar in sync (shareable / refresh). */
  function setVariantInUrl(variantId) {
    if (!variantId) return;
    if (typeof window.history === 'undefined' || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      var next = url.pathname + url.search + url.hash;
      var cur = window.location.pathname + window.location.search + window.location.hash;
      if (next !== cur) window.history.replaceState({}, '', next);
    } catch (e) {
      /* ignore */
    }
  }

  function getAnchorMediaIdSet() {
    return new Set(
      Array.from(document.querySelectorAll('.product-swatch-option[data-variant-media-id]'))
        .map(function (el) {
          return el instanceof HTMLElement ? el.dataset.variantMediaId : '';
        })
        .filter(Boolean)
        .map(String)
    );
  }

  /**
   * Segment = images from last anchor index <= featured through the next anchor (by media order).
   * No anchors / no id -> full gallery.
   */
  function sliceGalleryGroupByAnchor(images, anchorMediaId, anchorSet) {
    if (!images || !images.length) return [];
    if (!anchorSet || !anchorSet.size) return images.slice();

    var idStr = String(anchorMediaId || '');
    if (!idStr) return images.slice();

    var boundaries = [];
    var i;
    var item;
    var n = images.length;

    for (i = 0; i < n; i++) {
      item = images[i];
      if (item == null) continue;
      if (anchorSet.has(String(item.id))) boundaries.push(i);
    }
    if (!boundaries.length) return images.slice();

    var featuredIndex = -1;
    for (i = 0; i < n; i++) {
      item = images[i];
      if (item != null && String(item.id) === idStr) {
        featuredIndex = i;
        break;
      }
    }
    if (featuredIndex < 0) return images.slice();

    var segmentStart = 0;
    for (i = 0; i < boundaries.length; i++) {
      if (boundaries[i] <= featuredIndex) segmentStart = boundaries[i];
    }

    var segmentEnd = n;
    for (i = 0; i < boundaries.length; i++) {
      if (boundaries[i] > segmentStart) {
        segmentEnd = boundaries[i];
        break;
      }
    }

    return images.slice(segmentStart, segmentEnd);
  }

  var productGalleryRefreshers = new WeakMap();

  function refreshProductGallery(gallery) {
    var fn = productGalleryRefreshers.get(gallery);
    if (typeof fn === 'function') fn();
  }

  function renderGalleryTrack(track, items) {
    track.textContent = '';
    if (!items || !items.length) return;

    var slideClass =
      'shrink-0 basis-full snap-start md:basis-auto md:shrink md:snap-none aspect-square';

    for (var j = 0; j < items.length; j++) {
      var row = items[j];
      if (!row || !row.src) continue;
      var slide = document.createElement('div');
      slide.className = slideClass;
      slide.setAttribute('data-product-gallery-slide', '');
      var img = document.createElement('img');
      img.className = 'product-image w-full h-full object-cover';
      img.src = row.src;
      img.alt = typeof row.alt === 'string' ? row.alt : '';
      img.loading = j === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      slide.appendChild(img);
      track.appendChild(slide);
    }
  }

  function syncProductGalleryForVariant(form, variantMediaId) {
    var grid = form.closest('.grid');
    var gallery = grid ? grid.querySelector('[data-product-gallery]') : null;
    if (!(gallery instanceof HTMLElement)) return;
    var track = gallery.querySelector('[data-product-gallery-track]');
    if (!(track instanceof HTMLElement)) return;

    var galleryImages = getProductGalleryImages();
    var anchorSet = getAnchorMediaIdSet();
    var group = sliceGalleryGroupByAnchor(galleryImages, variantMediaId || '', anchorSet);
    renderGalleryTrack(track, group);
    track.scrollLeft = 0;
    refreshProductGallery(gallery);
  }

  function syncPdpWishlistToggle(form, variantId) {
    var root = form.closest('.product-form');
    if (!(root instanceof HTMLElement)) root = form;
    var btn = root.querySelector('[data-wishlist-toggle]');
    if (!(btn instanceof HTMLElement)) return;
    btn.dataset.variantId = String(variantId);
    document.dispatchEvent(new CustomEvent('wishlist:sync-ui'));
  }

  /** Add-to-cart disabled state + label from selected variant (`data-available` on options). */
  function syncProductSubmitButton(form) {
    if (!(form instanceof HTMLFormElement)) return;
    var variantSelect = form.querySelector('[data-product-variant-select]');
    if (!(variantSelect instanceof HTMLSelectElement)) return;

    var option = variantSelect.selectedOptions[0];
    if (!(option instanceof HTMLOptionElement)) return;

    var available = option.getAttribute('data-available') === 'true';

    var root = form.querySelector('[data-cart-submit-root]');
    if (!(root instanceof HTMLElement)) return;

    var submitBtn = root.querySelector('[data-product-submit]');
    if (!(submitBtn instanceof HTMLButtonElement)) return;

    var labelEl = root.querySelector('[data-product-add-label]');
    var addLabel = root.dataset.addToCartLabel || '';
    var soldOutLabel = root.dataset.soldOutLabel || '';

    submitBtn.disabled = !available;
    if (labelEl) {
      labelEl.textContent = available ? addLabel : soldOutLabel;
    }
  }

  forms.forEach(function (form) {
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.swatchBound === 'true') return;

    bindShortDescription(form);

    var variantSelect = form.querySelector('[data-product-variant-select]');
    if (!(variantSelect instanceof HTMLSelectElement)) return;

    var priceNode = form.querySelector('[data-product-price]');
    var compareNode = form.querySelector('[data-product-compare-at]');
    var skuNode = form.querySelector('[data-product-sku]');
    var selectedColorNode = form.querySelector('[data-selected-color]');
    var swatches = Array.from(form.querySelectorAll('.product-swatch-option'));
    var pills = Array.from(form.querySelectorAll('.product-variant-pill'));

    var variantData = null;
    var vdNode = form.querySelector('[data-product-variant-data]');
    if (vdNode) {
      try { variantData = JSON.parse(vdNode.textContent || ''); } catch (e) { /* ignore */ }
    }

    function getVariantEntry(id) {
      if (!variantData) return null;
      var s = String(id);
      for (var i = 0; i < variantData.variants.length; i++) {
        if (String(variantData.variants[i].id) === s) return variantData.variants[i];
      }
      return null;
    }

    function findVariantByOptions(opts) {
      if (!variantData) return null;
      for (var i = 0; i < variantData.variants.length; i++) {
        var v = variantData.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function setActiveSwatch(variantId) {
      swatches.forEach(function (swatch) {
        if (!(swatch instanceof HTMLButtonElement)) return;
        var isActive = swatch.dataset.variantId === String(variantId);
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function setActivePills() {
      if (!variantData || !pills.length) return;
      var entry = getVariantEntry(variantSelect.value);
      if (!entry) return;
      pills.forEach(function (pill) {
        if (!(pill instanceof HTMLButtonElement)) return;
        var isActive = entry.options[Number(pill.dataset.optionIndex)] === pill.dataset.optionValue;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function syncProductSku(variantId) {
      if (!variantData || !(skuNode instanceof HTMLElement)) return;
      var entry = getVariantEntry(variantId);
      if (!entry) return;
      skuNode.textContent =
        entry.sku != null && entry.sku !== '' ? String(entry.sku) : '';
    }

    variantSelect.addEventListener('change', function () {
      setVariantInUrl(variantSelect.value);
      syncPdpWishlistToggle(form, variantSelect.value);
      syncProductSubmitButton(form);
      syncProductSku(variantSelect.value);
    });

    swatches.forEach(function (swatch) {
      if (!(swatch instanceof HTMLButtonElement)) return;
      swatch.addEventListener('click', function (event) {
        var btn = event.currentTarget;
        if (!(btn instanceof HTMLButtonElement)) return;

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var variantMediaId = btn.dataset.variantMediaId || '';

        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        setActiveSwatch(variantId);
        setActivePills();

        var variantPrice = btn.dataset.variantPrice;
        if (priceNode instanceof HTMLElement && variantPrice) {
          priceNode.textContent = variantPrice;
        }
        var vca = btn.dataset.variantCompareAt || '';
        if (compareNode instanceof HTMLElement) {
          compareNode.textContent = vca;
          compareNode.hidden = !vca;
        }

        var colorName = btn.dataset.colorName;
        if (selectedColorNode instanceof HTMLElement && colorName) {
          selectedColorNode.textContent = colorName;
        }

        syncProductGalleryForVariant(form, variantMediaId);
        syncPdpWishlistToggle(form, variantId);
      });
    });

    pills.forEach(function (pill) {
      if (!(pill instanceof HTMLButtonElement)) return;
      pill.addEventListener('click', function () {
        var entry = getVariantEntry(variantSelect.value);
        if (!entry) return;
        var opts = entry.options.slice();
        opts[Number(pill.dataset.optionIndex)] = pill.dataset.optionValue;
        var match = findVariantByOptions(opts);
        if (!match) return;

        variantSelect.value = String(match.id);
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        if (priceNode instanceof HTMLElement) priceNode.textContent = match.price_formatted;
        if (compareNode instanceof HTMLElement) {
          var cap = match.compare_at_formatted || '';
          compareNode.textContent = cap;
          compareNode.hidden = !cap;
        }
        setActiveSwatch(String(match.id));
        setActivePills();

        if (match.featured_media_id) {
          syncProductGalleryForVariant(form, String(match.featured_media_id));
        }
      });
    });

    setActiveSwatch(variantSelect.value);
    setActivePills();
    syncPdpWishlistToggle(form, variantSelect.value);
    syncProductSubmitButton(form);
    form.dataset.swatchBound = 'true';
  });

  forms.forEach(function (form) {
    if (!(form instanceof HTMLFormElement)) return;
    var grid = form.closest('.grid');
    var gallery = grid ? grid.querySelector('[data-product-gallery]') : null;
    if (!(gallery instanceof HTMLElement)) return;
    var track = gallery.querySelector('[data-product-gallery-track]');
    if (!(track instanceof HTMLElement)) return;

    var activeSwatch = form.querySelector('.product-swatch-option.is-active');
    var variantMediaId =
      activeSwatch instanceof HTMLElement ? activeSwatch.dataset.variantMediaId || '' : '';

    var galleryImages = getProductGalleryImages();
    var anchorSet = getAnchorMediaIdSet();
    var group = sliceGalleryGroupByAnchor(galleryImages, variantMediaId, anchorSet);
    renderGalleryTrack(track, group);
  });

  function bindProductGallery(gallery) {
    if (!(gallery instanceof HTMLElement)) return;
    if (gallery.dataset.galleryBound === 'true') return;

    var track = gallery.querySelector('[data-product-gallery-track]');
    var controls = gallery.querySelector('[data-product-gallery-controls]');
    var counter = gallery.querySelector('[data-product-gallery-counter]');
    var prevBtn = gallery.querySelector('[data-product-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-product-gallery-next]');

    if (!(track instanceof HTMLElement)) return;

    function getSlides() {
      return Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function prefersReduced() {
      return (
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    function setControlsVisibility() {
      var slideEls = getSlides();
      var show = isMobile() && slideEls.length > 1;
      if (controls instanceof HTMLElement) controls.hidden = !show;
      if (counter instanceof HTMLElement) counter.hidden = !show;
    }

    function getIndex() {
      var slideEls = getSlides();
      if (!isMobile()) return 0;
      if (!slideEls.length) return 0;
      var width = track.clientWidth || 1;
      var raw = Math.round(track.scrollLeft / width);
      return Math.max(0, Math.min(slideEls.length - 1, raw));
    }

    function scrollToIndex(index) {
      var slideEls = getSlides();
      if (!slideEls.length) return;
      var safeIndex = Math.max(0, Math.min(slideEls.length - 1, index));
      var target = slideEls[safeIndex];
      if (!(target instanceof HTMLElement)) return;
      target.scrollIntoView({
        behavior: prefersReduced() ? 'auto' : 'smooth',
        inline: 'start',
        block: 'nearest',
      });
    }

    function update() {
      var index = getIndex();
      var slideEls = getSlides();

      gallery.querySelectorAll('[data-product-gallery-dot]').forEach(function (dot, i) {
        if (!(dot instanceof HTMLButtonElement)) return;
        var active = i === index;
        dot.classList.toggle('bg-black/80', active);
        dot.classList.toggle('bg-black/25', !active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (counter instanceof HTMLElement) {
        counter.textContent = slideEls.length > 0 ? index + 1 + ' / ' + slideEls.length : '';
      }

      if (prevBtn instanceof HTMLButtonElement) {
        prevBtn.disabled = slideEls.length === 0 || index <= 0;
      }
      if (nextBtn instanceof HTMLButtonElement) {
        nextBtn.disabled = slideEls.length === 0 || index >= slideEls.length - 1;
      }
    }

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    gallery.querySelectorAll('[data-product-gallery-dot]').forEach(function (dot) {
      if (!(dot instanceof HTMLButtonElement)) return;
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.index || 0);
        scrollToIndex(index);
      });
    });

    if (prevBtn instanceof HTMLButtonElement) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(getIndex() - 1);
      });
    }

    if (nextBtn instanceof HTMLButtonElement) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(getIndex() + 1);
      });
    }

    window.addEventListener(
      'resize',
      function () {
        setControlsVisibility();
        update();
      },
      { passive: true }
    );

    productGalleryRefreshers.set(gallery, function () {
      setControlsVisibility();
      update();
    });

    setControlsVisibility();
    update();
    gallery.dataset.galleryBound = 'true';
  }

  var galleries = Array.from(document.querySelectorAll('[data-product-gallery]'));
  galleries.forEach(bindProductGallery);
})();
